import { store } from "../stores/mainStore";
import {throttle} from 'lodash';


// var theme = 'traditional';
// var timer;

export function preload() {
	const m = window.manager;
	store.phaserLoading = true;
	console.log('phaser loading');
	// this.load.on('progress', function (value) {
	// 	console.log(value);
	// });

	// this.load.on('fileprogress', function (file) {
	// 	console.log(file.src);
	// });

	if(m.sceneRestarting === true) {
		if(window.location.port === '3000' || window.location.hash === '#dev')
			this.load.audioSprite('sfx', m.assetURL + '/sounds/dod_R7_audioSprite.json', [m.assetURL + '/sounds/dod_R7_audioSprite.ogg', m.assetURL + '/sounds/dod_R7_audioSprite.mp3']);
		return;
	}

	this.load.once('complete', function() {
		console.log('phaser load complete');
		if (store.phaserLoading === true) {
			// integration.postAnalyticsEvent('assets-loaded', 'timing', Math.ceil((Date.now() - window.startTime) / 1000));
			if (store.gameFromResume || store.resuming) {
				// integration.onLoad(); //not used in standalone native game
			}
		}
		store.phaserLoading = false;
		if (store.tutorialMode) {
			store.tutorialState = 'avaOpponent';
		}
	});

	this.load.on('progress', throttle(function(value) {
		store.phaserLoadPercentage = Math.floor(value * 100);
	}, 550, {
		leading: false,
		trailing: true
	}));

	// this.load.setBaseURL('http://doddev2.com/phaserTest');

	// if(!WrapperApp)
	if(window.location.port === '3000' || window.location.hash === '#dev')
		this.load.audioSprite('sfx', m.assetURL + '/sounds/dod_R7_audioSprite.json', [m.assetURL + '/sounds/dod_R7_audioSprite.ogg', m.assetURL + '/sounds/dod_R7_audioSprite.mp3']);
	// this.load.audio('backgroundMusic', m.assetURL+'/sounds/music_vegas.mp3', { instances: 1 });

	this.load.plugin('rexscrollerplugin', 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexscrollerplugin.min.js', true);

	//all game image loading:

	//multiatlases:

	//language loading
	let lang = store.getLanguage;
	switch (lang) {
		case 'fr':
		case 'es':
		case 'de':
		case 'it':
			break;
		default:
			lang = 'en';
			break;
	}

	this.load.multiatlas('language', m.assetURL + '/languages/'+lang+'-phaser.json?cache=' + Date.now().toString(), m.assetURL + '/languages');
	this.load.multiatlas('common', m.assetURL + '/sprite_sheets/common-phaser.json', m.assetURL + '/sprite_sheets');
	//TODO: Detect Tutorial will load and load this
	this.load.multiatlas('tutorial', m.assetURL + '/languages/'+lang+'-tutorial.json?cache=' + Date.now().toString(), m.assetURL + '/languages');

	//TODO: Move this sprite sheet to language file
	this.load.spritesheet('msg_challenge', m.assetURL + '/sprite_sheets/msg_challenge/'+lang+'.png?v=1', {frameWidth: 976,frameHeight: 130});

	this.load.spritesheet('bigWinPanel', m.assetURL + '/sprite_sheets/big_win/'+lang+'.png?v=1', {frameWidth: 438,frameHeight: 74});
	this.load.spritesheet('flair', m.assetURL + '/sprite_sheets/flair/'+lang+'.png?v=1', {frameWidth: 338,frameHeight: 336});
	this.load.spritesheet('flairYellowDot', m.assetURL + '/sprite_sheets/flair_yellow/'+lang+'.png?v=1', {frameWidth: 338,frameHeight: 336});
	this.load.spritesheet('goalPanel', m.assetURL + '/sprite_sheets/goal_panel/'+lang+'.png?v=1', {frameWidth: 306,frameHeight: 76});
	this.load.spritesheet('selectDice', m.assetURL + '/sprite_sheets/selectDice/'+lang+'.png?v=1', {frameWidth: 494, frameHeight: 79});
	this.load.image('9_hand_scorecard_new', m.assetURL + '/sprite_sheets/9_hand_scorecard_new/'+lang+'.jpg?v=1');
	//end language loading

	this.load.multiatlas('floatingStars', m.assetURL + '/sprite_sheets/floatingStars.json', m.assetURL + '/sprite_sheets');
	this.load.multiatlas('poofNoCloud', m.assetURL + '/sprite_sheets/poofNoCloud.json', m.assetURL + '/sprite_sheets');
	this.load.multiatlas('swirl', m.assetURL + '/sprite_sheets/swirl.json', m.assetURL + '/sprite_sheets');

	//spritesheets:
	this.load.spritesheet('dice3D_sheet', m.assetURL + '/sprite_sheets/traditional_3d_spriteSheet.png', {
		frameWidth: 256,
		frameHeight: 256
	});
	this.load.spritesheet('dice2D_sheet', m.assetURL + '/sprite_sheets/traditional_2d_spriteSheet.png', {
		frameWidth: 226,
		frameHeight: 226
	});
	this.load.spritesheet('dice2D_sheet_64', m.assetURL + '/sprite_sheets/traditional_2d_spriteSheet_64_wide.png', {
		frameWidth: 64,
		frameHeight: 64
	});
	this.load.spritesheet('button_help', m.assetURL + '/btn_help.png', {
		frameWidth: 85,
		frameHeight: 81
	});
	this.load.spritesheet('button_zoom', m.assetURL + '/btn_zoom.png', {
		frameWidth: 82,
		frameHeight: 86
	});
	this.load.spritesheet('button_info', m.assetURL + '/btn_info.png', {
		frameWidth: 85,
		frameHeight: 81
	});
	this.load.spritesheet('zoomer', m.assetURL + '/zoomers.png', {
		frameWidth: 250,
		frameHeight: 250
	});
	// this.load.spritesheet('selectDice', m.assetURL + '/SelectDice.png', {
	// 	frameWidth: 494,
	// 	frameHeight: 79
	// });
	this.load.spritesheet('hand', m.assetURL + '/hand_sheet.png', {
		frameWidth: 178,
		frameHeight: 181
	});
	//cup
	this.load.spritesheet('cup_sheet', m.assetURL + '/cup_sheet.png', {
		frameWidth: 180,
		frameHeight: 185
	});
	// this.load.spritesheet('cup_sheet', m.assetURL + '/cup_sheet.png', {
	// 	frameWidth: 303.66,
	// 	frameHeight: 312
	// });

	this.load.spritesheet('blueBoxSprites', m.assetURL + '/BlueBoxSprites.png', {
		frameWidth: 225,
		frameHeight: 56
	});
	this.load.spritesheet('portrait_blur', m.assetURL + '/portrait_blurr.jpg', {
		frameWidth: 232,
		frameHeight: 227.6
	});
	//end spritesheets

	//begin discreet loaded images:
	this.load.image('playfieldNoFrame', m.assetURL + '/game/playfieldNoFrame.jpg'); //large dimensions
	this.load.image('playfieldFrame', m.assetURL + '/game/playfieldFrame.png'); //large dimensions
	// this.load.image('9_hand_scorecard_new', m.assetURL + '/9_hand_scorecard_new.jpg');
	this.load.image('border', m.assetURL + '/game/bumper320thick.jpg');  //left out of sprite sheet.
	this.load.image('portrait_unknown', m.assetURL + '/profile/portrait_unknown.jpg'); //leaving solo used in a unique way
	this.load.image('portrait_Ava', m.assetURL + '/bots/Ava.png');
	this.load.image('scorecard_header_slider', m.assetURL + '/game/scorecard_header_slider.png');
	this.load.image('scorecard_backing', m.assetURL + '/game/scorecard_backing.png');
	this.load.image('header_scorecard_holes_new', m.assetURL + '/game/header_scorecard_holes_new.png');

	this.load.image('dimPanel', m.assetURL + '/game/dimPanel.png');
	this.load.image('profile_default', m.assetURL + '/profile/profile_default.jpg');
	this.load.image('rays', m.assetURL + '/game/rays.png');
	this.load.image('gameHudLogoCover', m.assetURL + '/hud_siu.png');
	this.load.image('gameHudBackCoverHR', m.assetURL + '/hud_theme_vegas_blue_HR.png');


	this.load.image('short_tutorial_box_keep_practicing', m.assetURL + '/languages/'+lang+'/short_tutorial_box_keep_practicing.png');
	this.load.image('short_tutorial_banner_epic', m.assetURL + '/languages/'+lang+'/short_tutorial_banner_epic.png');
	this.load.image('short_tutorial_box_easy_to_win', m.assetURL + '/languages/'+lang+'/short_tutorial_box_easy_to_win.png');
	this.load.image('short_tutorial_msg_roll', m.assetURL + '/languages/'+lang+'/short_tutorial_msg_roll.png');
	this.load.image('btn_done_practicing', m.assetURL + '/languages/'+lang+'/btn_done_practicing.png');
	this.load.image('btn_keep_practicing', m.assetURL + '/languages/'+lang+'/btn_keep_practicing.png');
	this.load.image('btn_take_me', m.assetURL + '/languages/'+lang+'/btn_take_me.png');
	this.load.image('btn_practice', m.assetURL + '/languages/'+lang+'/btn_practice.png');
	this.load.image('pinkHeart_5', m.assetURL + '/pinkHeart_5.png');
	this.load.image('pinkHeart_1', m.assetURL + '/pinkHeart_1.png');
	this.load.image('turn_indicator_1_turn', m.assetURL + '/turn_indicator_1_turn.png');
	this.load.image('btn_play_again', m.assetURL + '/btn_play_again_1_turn.png');
	this.load.image('btn_get_on_google_play', m.assetURL + '/download-for-android.png');
	this.load.image('btn_download_appstore', m.assetURL + '/btn_download_appstore.png');
	this.load.image('check_1_turn', m.assetURL + '/check_1_turn.png');
	this.load.image('msg_1_turn_download_now', m.assetURL + '/msg_1_turn_download_now.png');
	
	this.load.image('box_end_3-hand_game_tie', m.assetURL + '/languages/'+lang+'/box_end_3-hand_game_tie.png');
	this.load.image('box_end_3-hand_game', m.assetURL + '/languages/'+lang+'/box_end_3-hand_game.png');
	this.load.image('box_end_3-hand_game_lose', m.assetURL + '/languages/'+lang+'/box_end_3-hand_game_lose.png');

	//end discreet loaded images:

}
